import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalReviews from "@faire/web-api--source/routes/brand-portal/analytics/reviews";
import supportArticle from "@faire/web-api--source/routes/support/articles/articleId";
import React, { type JSX } from "react";

import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";

export const DisputeReviewIA = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="You can flag a customer review for removal if it’s inappropriate or violates <LinkFormatting>Faire policies</LinkFormatting>."
          values={{
            LinkFormatting: ArticleLinkFormatting,
          }}
          description={{
            text: "Introduction to flagging a review",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="To flag a review:"
          description={{
            text: "Header of the list in how to flag a review",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <ol>
        <LiItem step={1}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Go to your <LinkFormatting>Reviews</LinkFormatting> page."
              values={{
                LinkFormatting: ReivewsLinkFormatting,
              }}
              description={{
                text: "First step to flag a review",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={2}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Find the specific review you’d like to flag. You can use the date filter or sort options at the top of the page to help locate it."
              description={{
                text: "Second step to flag a review",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={3}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Select <BoldFormatting>Flag for removal</BoldFormatting> located directly under the comment."
              values={{
                BoldFormatting,
              }}
              description={{
                text: "Third step to flag a review",
              }}
            />
          </Typography>
        </LiItem>
      </ol>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="Reviews containing explicit language, spam, or feedback not specific to your brand, among other issues, can be flagged. Once flagged, the review will be temporarily removed from your shop during the review process. You’ll be notified by email if the review is found to violate policy, and it will be permanently removed from your shop page."
          description={{
            text: "Additional information about the review process",
          }}
        />
      </Typography>
    </Column>
  );
};

const ArticleLinkFormatting = (chunks: JSX.Element) => (
  <Button
    variant="tertiary"
    linkTo={supportArticle("360030184911")}
    target="_blank"
  >
    {chunks}
  </Button>
);

const ReivewsLinkFormatting = (chunks: JSX.Element) => (
  <Button variant="tertiary" linkTo={brandPortalReviews()} target="_blank">
    <Bold>{chunks}</Bold>
  </Button>
);

const BoldFormatting = (chunks: JSX.Element) => <Bold>{chunks}</Bold>;
